module.exports = __webpack_public_path__ + "img/pic_470018.dd6fc2e4.jpg";